import { t } from "i18next";
import { PopupTemplates } from "../../../components/deprecated/PopupTemplates/PopupTemplates";
import { ToastUtilities } from "../../../libs/react-toastify/ToastUtilities";
import { CustomFieldDataType } from "../Company/Collections/CustomFieldDataType";
import { CustomFieldDataTypeHelper } from "../Company/Collections/CustomFieldDataTypeHelper/CustomFieldDataTypeHelper";
import { FirebaseData } from "../General/FirebaseData";
import { LocalData } from "../General/LocalData";
import { TranslationData } from "../General/TranslationData";
import { CustomFieldDataOptions, PropertyCustomFieldData } from "../Property/Collections/PropertyCustomFieldData";
import { CollectionData } from "./CollectionData";

export class CollectionFieldData extends FirebaseData {
  name: TranslationData = new TranslationData();
  collection: CollectionData | undefined = undefined;

  fieldID: string = "";

  dataType: CustomFieldDataTypeHelper<any> = CustomFieldDataType.TEXT;
  dataOptions: CustomFieldDataOptions = PropertyCustomFieldData.getDefaultOptions();

  deprecated: boolean = false;
  isReference: boolean = false;

  setup(data: any) {
    this.name.setup(data.name);
    this.collection = typeof data.collectionID === "string" ? LocalData.collections.addData(data.collectionID) : undefined;
    this.fieldID = typeof data.fieldID === "string" ? data.fieldID : "";

    this.dataType = CustomFieldDataType.getTypeWithId(data.dataType);

    if (typeof data.dataOptions === "object") {
      this.dataOptions = {
        timeEnabled: typeof data.dataOptions.timeEnabled === "boolean" ? data.dataOptions.timeEnabled : false,
        dateEnabled: typeof data.dataOptions.dateEnabled === "boolean" ? data.dataOptions.dateEnabled : true,
        contractorAccess: typeof data.dataOptions.contractorAccess === "boolean" ? data.dataOptions.contractorAccess : undefined,
        formula: typeof data.dataOptions.formula === "string" ? data.dataOptions.formula : undefined,
        collectionID: typeof data.dataOptions.collectionID === "string" ? data.dataOptions.collectionID : undefined,
        standardID: typeof data.dataOptions.standardID === "string" ? data.dataOptions.standardID : undefined,
        customDataTypeID: typeof data.dataOptions.customDataTypeID === "string" ? data.dataOptions.customDataTypeID : undefined,
        isMulti: typeof data.dataOptions.isMulti === "boolean" ? data.dataOptions.isMulti : undefined,
        previewFiles: typeof data.dataOptions.previewFiles === "boolean" ? data.dataOptions.previewFiles : undefined,
        hideParentReference: typeof data.dataOptions.hideParentReference === "boolean" ? data.dataOptions.hideParentReference : undefined,
      };
    }

    this.deprecated = typeof data.deprecated === "boolean" ? data.deprecated : false;
    this.isReference = typeof data.isReference === "boolean" ? data.isReference : false;

    super.setup(data);
  }

  deleteCustomField(onFinish: () => void) {
    PopupTemplates.presentVerifyDelete(this.name.translate(), () => {
      ToastUtilities.presentPromise(
        t("main.deleting") + " " + this.name.translate(),
        LocalData.collectionFields.deleteDocument(this.id).then(() => {
          onFinish();
        })
      );
    });
  }
}

